import { render, staticRenderFns } from "./adjust-policy-info.vue?vue&type=template&id=728758cc&scoped=true&"
import script from "./adjust-policy-info.vue?vue&type=script&lang=js&"
export * from "./adjust-policy-info.vue?vue&type=script&lang=js&"
import style0 from "./adjust-policy-info.vue?vue&type=style&index=0&id=728758cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728758cc",
  null
  
)

export default component.exports